/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_Get_AppInputs */

const en_try_magic_get_app = /** @type {(inputs: Try_Magic_Get_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the app`)
};

const es_try_magic_get_app = /** @type {(inputs: Try_Magic_Get_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga la app`)
};

/**
* | output |
* | --- |
* | "Get the app" |
*
* @param {Try_Magic_Get_AppInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_get_app = /** @type {((inputs?: Try_Magic_Get_AppInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_Get_AppInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_get_app(inputs)
	return en_try_magic_get_app(inputs)
});